module.exports = __webpack_public_path__ + "img/taxi-logo.fb02f345.png";